import { GA4Config } from '@/lib/ga4-types';

// Analytics Configuration
export const ANALYTICS_CONFIG: GA4Config = {
  measurementId: import.meta.env.VITE_GA4_MEASUREMENT_ID || '',
  debugMode: import.meta.env.VITE_GA4_DEBUG_MODE === 'true',
  customParameters: {
    app_name: 'Statemia',
    app_version: '1.0.0',
    environment: import.meta.env.MODE
  }
};

// Check if GA4 is properly configured
export const isAnalyticsConfigured = (): boolean => {
  return !!ANALYTICS_CONFIG.measurementId && 
         ANALYTICS_CONFIG.measurementId.startsWith('G-');
};

// Get environment-specific settings
export const getAnalyticsSettings = () => {
  const isProduction = import.meta.env.PROD;
  const isConfigured = isAnalyticsConfigured();
  
  return {
    isProduction,
    isConfigured,
    measurementId: ANALYTICS_CONFIG.measurementId,
    debugMode: ANALYTICS_CONFIG.debugMode && !isProduction,
    shouldTrack: isConfigured && (isProduction || ANALYTICS_CONFIG.debugMode)
  };
};

// Development warning
if (import.meta.env.DEV && !isAnalyticsConfigured()) {
  // console.warn(`
  // 🚨 Google Analytics 4 no está configurado!
  // 
  // Para configurar GA4:
  // 
  // 1. Ve a https://analytics.google.com
  // 2. Crea una cuenta y propiedad
  // 3. Copia el Measurement ID (G-XXXXXXXXXX)
  // 4. Agrega a tu .env.local:
  //    VITE_GA4_MEASUREMENT_ID=G-XXXXXXXXXX
  //    VITE_GA4_DEBUG_MODE=true
  // 
  // Sin esto, el tracking no funcionará.
  // `); // Removed for production
} 